import BaseSetup from '@/components/BaseSetup';

export type SharedSettingCardEmits = {};

export type SharedSettingCardProps = {
	title?: string
	fontIcon?: string
};

export default class SharedSettingCardSetup extends BaseSetup {

	static readonly defaultProps = {};

	constructor (
		private props: SharedSettingCardProps,
		private emits: SharedSettingCardEmits,
	) {
		super();
	}

}
